var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinoculars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.99 50.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "_426_Binoculars_field_glasses_search_vision",
    "data-name": "426, Binoculars, field glasses, search, vision"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m46.68,45.67h-21.07c-.3,0-.61-.1-.81-.4-.2-.2-.3-.61-.3-.91l1.21-16.33c0-.6.5-1.11,1.21-1.11h18.65c.61,0,1.11.5,1.21,1.11l1.21,16.33c0,.3-.1.6-.3.91-.4.2-.71.4-1.01.4Zm-19.76-2.32h18.55l-1.01-14.01h-16.54l-1.01,14.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m39.83,12.1h-6.65c-.61,0-1.21-.5-1.21-1.21v-4.94c0-.6.5-1.21,1.21-1.21h6.65c.6,0,1.21.5,1.21,1.21v4.94c-.1.71-.61,1.21-1.21,1.21Zm-5.55-2.32h4.34v-2.62h-4.34v2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m41.74,7.06h-10.59c-.61,0-1.21-.5-1.21-1.21V1.21c0-.6.5-1.21,1.21-1.21h10.49c.6,0,1.21.5,1.21,1.21v4.64c0,.71-.5,1.21-1.11,1.21Zm-9.38-2.32h8.17v-2.32h-8.17v2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m42.04,50.31h-11.19c-.6,0-1.21-.5-1.21-1.21v-4.64c0-.61.5-1.21,1.21-1.21h11.29c.61,0,1.21.5,1.21,1.21v4.64c-.1.71-.6,1.21-1.31,1.21Zm-10.08-2.32h8.97v-2.32h-8.97v2.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m22.18,45.67H1.11c-.3,0-.61-.1-.81-.4-.2-.2-.3-.61-.3-.91l1.21-16.33c0-.6.5-1.11,1.21-1.11h18.65c.6,0,1.11.5,1.21,1.11l1.21,16.33c0,.3-.1.6-.3.91-.4.2-.71.4-1.01.4Zm-19.76-2.32h18.55l-1.01-14.01H3.33l-.91,14.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m14.92,12.1h-6.75c-.61,0-1.21-.5-1.21-1.21v-4.94c0-.6.5-1.21,1.21-1.21h6.75c.6,0,1.21.5,1.21,1.21v4.94c0,.71-.61,1.21-1.21,1.21Zm-5.54-2.32h4.44v-2.62h-4.44v2.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m16.74,7.06H6.35c-.6,0-1.21-.5-1.21-1.21V1.21c0-.6.5-1.21,1.21-1.21h10.49c.6,0,1.21.5,1.21,1.21v4.64c-.1.71-.6,1.21-1.31,1.21Zm-9.28-2.32h8.07v-2.32H7.46v2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m17.14,50.31H5.95c-.6,0-1.21-.5-1.21-1.21v-4.64c0-.61.5-1.21,1.21-1.21h11.29c.6,0,1.21.5,1.21,1.21v4.64c-.1.71-.6,1.21-1.31,1.21Zm-10.08-2.32h8.97v-2.32H7.06v2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m45.47,40.93h-9.38c-.61,0-1.21-.5-1.21-1.21s.5-1.21,1.21-1.21h9.38c.61,0,1.21.5,1.21,1.21s-.5,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m11.59,40.93H2.22c-.61,0-1.21-.5-1.21-1.21s.5-1.21,1.21-1.21h9.38c.6,0,1.21.5,1.21,1.21s-.5,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m16.33,40.93h-1.21c-.6,0-1.21-.5-1.21-1.21s.5-1.21,1.21-1.21h1.21c.61,0,1.21.5,1.21,1.21s-.6,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m32.67,40.93h-1.21c-.61,0-1.21-.5-1.21-1.21s.5-1.21,1.21-1.21h1.21c.61,0,1.21.5,1.21,1.21s-.6,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m38.51,29.34c-.61,0-1.21-.5-1.21-1.21v-9.88c0-.61.5-1.21,1.21-1.21s1.21.5,1.21,1.21v9.88c-.1.6-.6,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m9.28,29.34c-.6,0-1.21-.5-1.21-1.21v-9.88c0-.61.5-1.21,1.21-1.21.61,0,1.21.5,1.21,1.21v9.88c0,.6-.5,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m42.85,29.34h-12.8c-.6,0-1.21-.5-1.21-1.21v-8.17c0-.61.5-1.21,1.21-1.21h.91c.61,0,1.21-.71,1.21-1.51s-.5-1.51-1.21-1.51h-.91c-.6,0-1.21-.5-1.21-1.21v-3.73c0-.61.5-1.21,1.21-1.21h12.91c.61,0,1.21.5,1.21,1.21v17.24c-.1.71-.6,1.31-1.31,1.31Zm-11.7-2.42h10.59v-14.82h-10.59v1.41c1.81.2,3.23,1.81,3.23,3.83s-1.41,3.63-3.23,3.83v5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m17.95,29.34H5.14c-.61,0-1.21-.5-1.21-1.21V10.89c0-.61.5-1.21,1.21-1.21h12.8c.61,0,1.21.5,1.21,1.21v3.73c0,.6-.5,1.21-1.21,1.21h-.81c-.71,0-1.21.71-1.21,1.51s.5,1.51,1.21,1.51h.81c.61,0,1.21.5,1.21,1.21v8.17c0,.5-.5,1.11-1.21,1.11Zm-11.59-2.42h10.49v-5.85c-1.82-.2-3.13-1.81-3.13-3.83s1.31-3.63,3.13-3.83v-1.41H6.35v14.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m30.85,21.07h-13.71c-1.92,0-3.53-1.71-3.53-3.83s1.51-3.83,3.53-3.83h13.71c2.02,0,3.53,1.71,3.53,3.83s-1.61,3.83-3.53,3.83Zm-13.71-5.34c-.71,0-1.21.71-1.21,1.51s.5,1.51,1.21,1.51h13.71c.61,0,1.21-.71,1.21-1.51s-.5-1.51-1.21-1.51h-13.71Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinoculars);
export default __webpack_public_path__ + "static/media/binoculars.1612e15a61c8e9e1f0363cb3c5cadaa1.svg";
export { ForwardRef as ReactComponent };